/**
 * Created by Ivan on 28.08.2025
 */

Reward.register("weekly_goals_points", {
    getIcon: function () {
        return bundles.reward_icons.frames.weekly_goal_points_png;
    },

    receive: function (value) {
        cleverapps.weeklyGoals.addPoints(value);

        return function () {};
    }
});